import {Component, Inject, Input, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DatePipe} from "@angular/common";
import {ViewIndividualAssessmentComponent} from "../view-individual-assessment/view-individual-assessment.component";
import firebase from "firebase/compat/app";
import Timestamp = firebase.firestore.Timestamp;
import {environment} from "../../../../../environments/environment";
import {UploadModel} from "../../../../models/UploadModel";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-view-group-session',
  templateUrl: './view-group-session.component.html',
  styleUrls: ['./view-group-session.component.scss']
})
export class ViewGroupSessionComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  env = isDevMode() ? environment.testMode : environment.productionMode
  mDocuments:UploadModel[]=[]
  mDbType: 'realtime' | 'firestore' = 'firestore';
  mStoragePath?: string = 'counselling/group-sessions'   //Path for Image Upload Location
  mPath = this.env.counseling;                    // Path for uploaded image url database location
  documents$: Observable<unknown | undefined>

  constructor(
      private readonly matDialogRef:MatDialogRef<ViewGroupSessionComponent>,
      private readonly datePipe:DatePipe,
      private readonly mStorage:AngularFireStorage,
      private readonly _snackBar:MatSnackBar,

      private readonly mFirestore:AngularFirestore,
      @Inject(MAT_DIALOG_DATA) public data: any

  ) {
    this.mStoragePath = this.mStoragePath + '/' + data.id
    this.mPath =this.env.documents+'/'+ this.mPath + '/groupSessions/' + data.id
    console.log(`Document will be uploaded to ${this.mStoragePath} on ${this.mDbType} in ${this.mPath} `)

    // Stamp root-level metadata so the photo gallery can query by date & centre
    const sessionDate = data.date || data.sessionDate || null;
    const centres: any[] = data.centres || [];
    const centreCode = centres.map((c: any) => c.centreCode).filter(Boolean).join(', ');
    const centreName = centres.map((c: any) => c.centreName).filter(Boolean).join(', ');
    this.mFirestore.doc(this.mPath).set({
      date:       sessionDate,
      dateAdded:  sessionDate,
      centreCode: centreCode || data.centreCode || '',
      centreName: centreName || data.centreName || '',
      centres:    centres,
    }, { merge: true });

    this.documents$  = this.mFirestore.doc( this.mPath).valueChanges({idField:'id'})
    this.documents$.pipe(takeUntil(this._destroyed$)).subscribe(res=>{
      // @ts-ignore
      this.mDocuments = res.documents as UploadModel
    })
  }
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
  getTopicsCovered(centres:any[]):string{
    let str=''
    centres.forEach((it,index)=>{
     if(centres.length-1==index)  str += it+' '
    else str += it+', '
    })
    return str
  }

  getDate(date: Timestamp) {
    return this.datePipe.transform(date.toDate(),'dd-MMM-yyyy')
  }
  getTime(date: Timestamp) {
    let dt = date.toDate()
    return this.datePipe.transform(date.toDate(),'shortTime')
    // return dt.get()
  }
  getchildNames(children: any[]):string {
    let str=''

    children.forEach((it,index)=>{
      if(children.length-1==index)  str += it.childName+' '
      else  str += it.childName+', '
    })
    return str
  }
  getParentNames(children: any[]):string {
    let str='k'
    children.forEach(it=>{
      str += it.parentsName+', '
    })
    return str
  }
  getCenterNames(centres: any) :string{
    let str=''
    centres.forEach((it: { centreName: string; }, index: number)=>{
      if(centres.length-1==index)  str += it.centreName+' '
      else  str += it.centreName+', '
    })

    return str
  }
  trackByMethod(index: number, el: any): number {
    return el.id;
  }
  openLink(fileUrl: string) {
    window.open(fileUrl)

  }

  @needConfirmation()
  deleteAdmissionFile(i: number, d: UploadModel, category: string) {
    const iRef = this.mStorage.storage.refFromURL(d.url)
    iRef.delete().then(() => {
      this.mFirestore.doc(this.mPath).update({
        [category]: firebase.firestore.FieldValue.arrayRemove(d)
      }).then(() => {
        this._snackBar.open('File Deleted Successfully')._dismissAfter(2000)
      })
    })
    console.log(iRef)
  }
}
